export default "__VITE_ASSET__BF$cExBo__"